export default {
  // Nav
  'nav.home': 'Strona główna',
  'nav.guide': 'Przewodnik',
  'nav.shoppingGuide': 'Przewodnik zakupowy',
  'nav.categories': 'Kategorie',
  'nav.safety': 'Bezpieczeństwo',
  'nav.brand': 'USFans Spreadsheet',

  // Hero
  'hero.eyebrow': 'CENTRUM ZASOBÓW USFANS SPREADSHEET',
  'hero.title': 'USFans Spreadsheet — znajdź, uporządkuj i poznaj informacje o twórcach',
  'hero.subtitle':
    'Poznaj praktyczne zasoby arkuszy USFans, przewodniki po twórcach, porównania, informacje o bezpieczeństwie i pomocne narzędzia, które sprawiają, że wyszukiwanie twórców jest szybsze, jaśniejsze i łatwiejsze do uporządkowania.',
  'hero.ctaPrimary': 'usfans spreadsheet',
  'hero.ctaSecondary': 'kup teraz',
  'hero.trust': 'Niezależne źródło · Praktyczne przewodniki · Nacisk na bezpieczeństwo · Regularnie aktualizowane',

  // Category section
  'category.title': 'Przeglądaj według kategorii',
  'category.subtitle':
    'Przejdź od razu do wybranej sekcji sklepu. Wybierz kategorię poniżej lub użyj listy rozwijanej, aby szybko nawigować.',
  'category.dropdownLabel': 'Wybierz kategorię',
  'category.browseAll': 'Przeglądaj cały katalog w sklepie',
  'category.featured': 'Popularne kategorie',

  // What is section
  'what.title': 'Czym jest arkusz USFans?',
  'what.p1':
    'Arkusz USFans to uporządkowany sposób na zebranie informacji o twórcach w jednym miejscu. Zamiast przeszukiwać rozproszone strony, użytkownicy mogą korzystać z zasobów w formie arkusza, aby efektywniej wyszukiwać, porównywać i zarządzać informacjami.',
  'what.p2':
    'Nasze Centrum Zasobów USFans Spreadsheet łączy praktyczne przewodniki, porównania, zasoby dotyczące bezpieczeństwa i treści edukacyjne, pomagając zrozumieć, jak działają te zasoby i jak z nich odpowiedzialnie korzystać.',
  'what.cta': 'Poznaj przewodnik po arkuszu USFans',

  // Benefits
  'benefit.title': 'Dlaczego warto korzystać z arkusza USFans?',
  'benefit.subtitle': 'Praktyczne zalety, które sprawiają, że zorganizowane wyszukiwanie jest prostsze i pewniejsze.',
  'benefit.1.title': 'Zorganizowane wyszukiwanie',
  'benefit.1.desc': 'Utrzymuj istotne informacje o twórcach w uporządkowanej i łatwiejszej do przeglądania formie.',
  'benefit.2.title': 'Szybsze odkrywanie',
  'benefit.2.desc': 'Korzystaj z zasobów zamiast polegać wyłącznie na rozproszonych wyszukiwaniach.',
  'benefit.3.title': 'Łatwiejsze porównywanie',
  'benefit.3.desc': 'Porównuj różne źródła informacji dzięki czytelnym tabelom i uporządkowanym przewodnikom.',
  'benefit.4.title': 'Lepsze decyzje',
  'benefit.4.desc': 'Zrozum, co oznaczają informacje, zanim na nich polegasz.',

  // Articles
  'articles.title': 'Najnowsze przewodniki po arkuszu USFans',
  'articles.subtitle':
    'Oryginalne, praktyczne przewodniki, które pomogą Ci zrozumieć, uporządkować i bezpiecznie korzystać z zasobów arkuszy.',
  'articles.readTime': '{{minutes}} min czytania',
  'articles.updated': 'Zaktualizowano',
  'articles.readMore': 'Przeczytaj artykuł',
  'articles.related': 'Powiązane przewodniki',

  // Comparison
  'comparison.title': 'Arkusz USFans a inne metody wyszukiwania',
  'comparison.subtitle': 'Zobacz, jak zorganizowane zasoby arkusza wypadają w porównaniu z innymi sposobami wyszukiwania.',
  'comparison.method': 'Metoda',
  'comparison.organization': 'Organizacja',
  'comparison.searchability': 'Możliwość wyszukiwania',
  'comparison.compare': 'Porównanie',
  'comparison.bestFor': 'Najlepsze do',
  'comparison.row1.name': 'Arkusz USFans',
  'comparison.row2.name': 'Wyszukiwanie ręczne',
  'comparison.row3.name': 'Katalog twórców',
  'comparison.row4.name': 'Nieuporządkowane listy',
  'comparison.high': 'Wysoka',
  'comparison.medium': 'Średnia',
  'comparison.low': 'Niska',
  'comparison.row1.best': 'Zorganizowane badania',
  'comparison.row2.best': 'Szybkie wyszukiwania',
  'comparison.row3.best': 'Przeglądanie',
  'comparison.row4.best': 'Podstawowy przegląd',
  'comparison.cta': 'Zobacz pełne porównanie',

  // Safety
  'safety.title': 'Bądź bezpieczny, korzystając z zasobów arkuszy online',
  'safety.subtitle': 'Kilka prostych nawyków chroni Twoje dane i spokój.',
  'safety.p1':
    'Nigdy nie udostępniaj haseł ani poufnych informacji nieznanym stronom. Sprawdzaj linki przed ich otwarciem, unikaj podejrzanych pobrań i ostrożnie traktuj niezweryfikowane listy twórców lub twierdzenia z arkuszy.',
  'safety.1': 'Sprawdzaj linki przed kliknięciem',
  'safety.2': 'Nigdy nie udostępniaj haseł',
  'safety.3': 'Unikaj podejrzanych pobrań',
  'safety.4': 'Kwestionuj niezweryfikowane twierdzenia',
  'safety.cta': 'Odwiedź Centrum Bezpieczeństwa',

  // Final CTA
  'final.title': 'Gotowy, aby poznać zasoby arkusza USFans?',
  'final.subtitle':
    'Zacznij od pełnego przewodnika po arkuszu USFans, a następnie poznaj zasoby twórców, porównania i informacje o bezpieczeństwie, które uczynią Twoje badania bardziej uporządkowanymi.',
  'final.cta': 'Poznaj arkusz USFans',

  // Footer
  'footer.tagline':
    'Niezależne źródło informacji o przewodnikach, porównaniach i bezpieczeństwie arkusza USFans.',
  'footer.resources': 'Zasoby',
  'footer.explore': 'Przeglądaj',
  'footer.legal': 'Informacje prawne',
  'footer.disclaimer':
    'USFanslink.makeup jest niezależnym źródłem informacji. Informacje mogą ulec zmianie, strony trzecie mogą zmieniać swoje zasady, a użytkownicy powinni samodzielnie weryfikować istotne informacje.',
  'footer.rights': 'Wszelkie prawa zastrzeżone.',
  'footer.store': 'Odwiedź sklep',

  // Categories
  'categories.shoes': 'Buty',
  'categories.hoodies': 'Bluzy/Swetry',
  'categories.tshirts': 'Koszulki',
  'categories.jackets': 'Kurtki',
  'categories.pants': 'Spodnie/Szorty',
  'categories.headwear': 'Nakrycia głowy',
  'categories.sets': 'Zestawy',
  'categories.underwear': 'Bielizna/Majtki',
  'categories.jersey': 'Koszulki sportowe',
  'categories.accessories': 'Akcesoria',
  'categories.bags': 'Torby',
  'categories.belts': 'Paski',
  'categories.perfumes': 'Perfumy',
  'categories.other': 'Inne rzeczy',
};